/**
 * A cloud production's status (PLAN §9.2) on the broadcast palette (D25):
 * `running` is on air, `starting` is next up, `pending` (created, or waiting
 * for a scheduled launch) is previewed, `stopping` warns, `stopped` is
 * offline and `failed` is destructive.
 */
import type { CloudProductionStatus } from '@acp/api-contract/cloudProductions.js';
import { Badge, type BadgeProps } from '../ui/badge.js';

const LOOK: Readonly<Record<CloudProductionStatus, { readonly label: string; readonly variant: NonNullable<BadgeProps['variant']> }>> = {
  pending: { label: 'Pending', variant: 'preview' },
  starting: { label: 'Starting', variant: 'next' },
  running: { label: 'Running', variant: 'onair' },
  stopping: { label: 'Stopping', variant: 'warning' },
  stopped: { label: 'Stopped', variant: 'offline' },
  failed: { label: 'Failed', variant: 'destructive' },
};

export function CloudProductionStatusBadge({ status }: { readonly status: CloudProductionStatus }) {
  const look = LOOK[status];
  return (
    <Badge variant={look.variant} data-testid="cloud-status" data-status={status}>
      {look.label}
    </Badge>
  );
}
